







import { Component } from "vue-property-decorator";
import { THEME_BTN_DETAIL_ACTION } from "@/constants/theme";
import CdkFavorite from "./CdkFavorite.vue";

@Component
export default class CdkFavoriteButton extends CdkFavorite {
  buttonTheme = THEME_BTN_DETAIL_ACTION;

  get buttonText() {
    if (this.isFavorite) {
      return this.$t("favoriteIsSaved");
    }

    return this.$t("saveAsFavorite");
  }
}
